import React from 'react';
import PropTypes from 'prop-types';
import Tip from './Tip';
import {NavLink} from 'react-router-dom';
import {generateRoutePath} from 'epic-common/src/route';
import root from 'window-or-global';

export default class Copy extends React.Component {
    static propTypes = {
        children: PropTypes.object.isRequired,
        text: PropTypes.string,
        tip: PropTypes.string,
        successTip: PropTypes.string,
        disabledTip: PropTypes.string,
        errorTip: PropTypes.string,
        onCopy: PropTypes.func,
        enableLink: PropTypes.bool
    };

    static defaultProps = {
        tip: 'Copy',
        successTip: 'Copied',
        errorTip: 'Copy Failed',
        disabledTip: 'Please fill tax and payout first'
    };

    constructor(props) {
        super(props);
        this.state = {
            tip: props.enableLink ? props.tip : props.disabledTip
        };
    }

    onClick = () => {
        const {successTip, errorTip, onCopy} = this.props;
        let success = false;
        const el = root.document.createElement('textarea');
        el.value = this.props.text;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.width = '2em';
        el.style.left = '-100em';
        root.document.body.appendChild(el);
        el.select();
        try {
            root.document.execCommand('copy');
            success = true;
        } catch (e) {
            // Can't copy, maybe older browser
        } finally {
            root.document.body.removeChild(el);
        }
        this.setState({tip: success ? successTip : errorTip});
        if (onCopy) {
            onCopy(success);
        }
    };

    onMouseLeave = () => {
        const {enableLink} = this.props;

        if (enableLink) {
            this.setState({tip: this.props.tip});
        }
    };

    render() {
        const {children, enableLink} = this.props;

        if (enableLink) {
            return (
                <div onMouseLeave={this.onMouseLeave} onClick={this.onClick}>
                    <Tip content={this.state.tip}>{children}</Tip>
                </div>
            );
        }

        return (
            <NavLink to={generateRoutePath('settings')}>
                <Tip content={this.state.tip}>{children}</Tip>
            </NavLink>
        );
    }
}
